import { Users, BarChart3, Map, Brain, HeartHandshake } from "lucide-react";

const problems = [
  {
    icon: Users,
    text: "Overcrowded coaching batches",
  },
  {
    icon: BarChart3,
    text: "Endless mock tests without analysis",
  },
  {
    icon: Map,
    text: "No personalized strategy",
  },
  {
    icon: Brain,
    text: "Confusion about career direction",
  },
  {
    icon: HeartHandshake,
    text: "Lack of mentorship",
  },
];

export default function ProblemSection() {
  return (
    <section
      id="problem"
      data-testid="problem-section"
      className="py-20 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          {/* Left - Title */}
          <div className="lg:col-span-5">
            <span className="text-sm font-semibold tracking-wider uppercase text-orange-600 font-body">
              The Problem
            </span>
            <h2
              data-testid="problem-title"
              className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-zinc-900 tracking-tight leading-tight mt-4"
            >
              Why Most CLAT Aspirants Struggle
            </h2>
          </div>

          {/* Right - Content */}
          <div className="lg:col-span-7">
            <div className="space-y-6">
              {problems.map((item, idx) => (
                <div
                  key={idx}
                  data-testid={`problem-item-${idx}`}
                  className="flex items-start gap-4 group"
                >
                  <div className="flex-shrink-0 w-10 h-10 rounded-full bg-orange-50 flex items-center justify-center group-hover:bg-orange-100 transition-colors">
                    <item.icon
                      size={18}
                      strokeWidth={1.5}
                      className="text-orange-600"
                    />
                  </div>
                  <p className="font-body text-base md:text-lg text-zinc-600 leading-relaxed pt-1.5">
                    {item.text}
                  </p>
                </div>
              ))}
            </div>

            <div className="mt-12 pl-14">
              <p
                data-testid="problem-conclusion"
                className="font-heading text-lg md:text-xl font-medium text-zinc-800 border-l-2 border-orange-400 pl-6"
              >
                Preparation needs structure, not noise.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
